import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const InsuranceIcon = (props) => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.812 1.17299L19.812 4.28399C20.535 4.60399 21 5.32099 21 6.11199V11C21 18.83 14.561 22.486 12 23C9.439 22.486 3 18.83 3 11V6.11199C3 5.31999 3.465 4.60399 4.188 4.28399L11.188 1.17299C11.705 0.942988 12.295 0.942988 12.812 1.17299ZM15 11H13V9C13 8.448 12.552 8 12 8C11.448 8 11 8.448 11 9V11H9C8.448 11 8 11.448 8 12C8 12.552 8.448 13 9 13H11V15C11 15.552 11.448 16 12 16C12.552 16 13 15.552 13 15V13H15C15.552 13 16 12.552 16 12C16 11.448 15.552 11 15 11Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

InsuranceIcon.propTypes = {
  sx: PropTypes.object,
};

export default InsuranceIcon;
